import type { IOpenAISchemaFunction } from '@rready/sdk';

export const updateTicketFieldDefinition: IOpenAISchemaFunction = {
  type: 'function',
  function: {
    name: 'updateTicketField',
    description:
      'Updates one field of the current idea, returning which field key to update, which value and the reason why to update this field with this value',
    parameters: {
      type: 'object',
      properties: {
        fieldKey: {
          type: 'string',
          description:
            'Json key to update, used in the full key format like "a.b.c"'
        },
        fieldValue: {
          type: 'string',
          description: 'Value to update the key with'
        },
        reason: {
          type: 'string',
          description:
            'Human readable explanation of this tool calling in the format: "Update {field} with {very short description of the value chosen and why}"'
        }
      },
      additionalProperties: false,
      required: ['fieldKey', 'fieldValue', 'reason']
    }
  },
  strict: true
};

function updateDeepValue(
  path: string,
  record: Record<string, unknown> | undefined,
  value: unknown
) {
  if (!path || !record) {
    return;
  }
  const keys = path.split('.');
  let current: any = record;
  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i];
    if (!Object.hasOwn(current, key)) {
      current[key] = {};
    }
    if (i === keys.length - 1) {
      current[key] = value;
    } else {
      current = current[key];
    }
  }
}

export type UpdateTicketFieldParams = {
  fieldKey: string;
  fieldValue: string;
  reason: string;
};
export const updateTicketFieldImplementation = (
  params: UpdateTicketFieldParams,
  ticket: Record<string, unknown>
) => {
  updateDeepValue(params.fieldKey, ticket, params.fieldValue);
};
